import React from "react";

import Link from "@khanacademy/wonder-blocks-link";

interface Props {
    fragmentId: string;
    onClick?: (id: string) => void;
    children: React.ReactElement | string;
}

export function InternalPageFragmentLink({
    fragmentId,
    onClick,
    children,
}: Props) {
    const handleClick = (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.(fragmentId);
    };

    return (
        <Link href={`#${fragmentId}`} inline onClick={handleClick}>
            {children}
        </Link>
    );
}
